import { render, staticRenderFns } from "./FOS.vue?vue&type=template&id=dffb97e2&"
import script from "./FOS.vue?vue&type=script&lang=js&"
export * from "./FOS.vue?vue&type=script&lang=js&"
import style0 from "./FOS.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports